import React from 'react';

/**
 * Honeypot Fields Component
 *
 * These fields are hidden from human users but visible to bots.
 * Bots will fill them in, triggering server-side detection.
 *
 * Fields are hidden using CSS positioning (not display:none which bots can detect)
 */

interface HoneypotFieldsProps {
  values: {
    website: string;
    company_url: string;
    phone2: string;
    address: string;
  };
  onChange: (field: string, value: string) => void;
}

export const HoneypotFields: React.FC<HoneypotFieldsProps> = ({ values, onChange }) => {
  const honeypotStyle: React.CSSProperties = {
    position: 'absolute',
    left: '-9999px',
    top: '-9999px',
    width: '1px',
    height: '1px',
    overflow: 'hidden',
    opacity: 0,
    pointerEvents: 'none',
  };

  return (
    <div style={honeypotStyle} aria-hidden="true">
      {/* Website field */}
      <label htmlFor="website">
        Website
        <input
          type="text"
          id="website"
          name="website"
          value={values.website}
          onChange={(e) => onChange('website', e.target.value)}
          tabIndex={-1}
          autoComplete="off"
        />
      </label>

      {/* Company URL field */}
      <label htmlFor="company_url">
        Company URL
        <input
          type="url"
          id="company_url"
          name="company_url"
          value={values.company_url}
          onChange={(e) => onChange('company_url', e.target.value)}
          tabIndex={-1}
          autoComplete="off"
        />
      </label>

      {/* Secondary phone field */}
      <label htmlFor="phone2">
        Secondary Phone
        <input
          type="tel"
          id="phone2"
          name="phone2"
          value={values.phone2}
          onChange={(e) => onChange('phone2', e.target.value)}
          tabIndex={-1}
          autoComplete="off"
        />
      </label>

      {/* Address field */}
      <label htmlFor="address">
        Address
        <input
          type="text"
          id="address"
          name="address"
          value={values.address}
          onChange={(e) => onChange('address', e.target.value)}
          tabIndex={-1}
          autoComplete="off"
        />
      </label>
    </div>
  );
};

export default HoneypotFields;
